export var PHONE_MEDIUM = 'medium-phone';
export var PHONE_LARGE = 'large-phone';
export var TABLET_SMALL = 'small-tablet';
export var TABLET = 'tablet';
export var DESKTOP = 'desktop';
export var DESKTOP_LARGE = 'large-desktop';
export var DESKTOP_LARGE_X = 'xlarge-desktop';
export var DESKTOP_LARGE_XX = 'xxlarge-desktop';
export var DESKTOP_4K = '4k-desktop';
export var PHONE_MEDIUM_MAX = 'medium-phone-max';
export var PHONE_LARGE_MAX = 'large-phone-max';
export var TABLET_SMALL_MAX = 'small-tablet-max';
export var TABLET_MAX = 'tablet-max';
export var DESKTOP_MAX = 'desktop-max';
export var DESKTOP_LARGE_MAX = 'large-desktop-max';
export var DESKTOP_LARGE_X_MAX = 'xlarge-desktop-max';
export var DESKTOP_LARGE_XX_MAX = 'xxlarge-desktop-max';
export var PHONE_MEDIUM_EXACT = 'medium-phone-exact';
export var PHONE_LARGE_EXACT = 'large-phone-exact';
export var TABLET_SMALL_EXACT = 'small-tablet-exact';
export var TABLET_EXACT = 'tablet-exact';
export var DESKTOP_EXACT = 'desktop-exact';
export var DESKTOP_LARGE_EXACT = 'large-desktop-exact';
export var DESKTOP_LARGE_X_EXACT = 'xlarge-desktop-exact';
export var DESKTOP_LARGE_XX_EXACT = 'xxlarge-desktop-exact';